import { GameConstants } from './../../GameConstants';
import { AvatarSpine } from './../room/players-container/SpineAvatar';
import { GameVars } from "../../GameVars";
import { Background } from "../background/Background";
import { GameManager } from '../../managers/GameManager';
import { Button } from '../../utils/Button';
import { Translation } from '../../Translation';

export class AnimationScene extends Phaser.Scene {

    public static currentInstance: AnimationScene;

    private avatars: AvatarSpine[];

    constructor() {

        super("AnimationScene");

        AnimationScene.currentInstance = this;

    }

    public create(): void {

        GameVars.currentScene = this;

        const background = new Background(this);
        this.add.existing(background);

        if (GameConstants.ANIMATION_SCENES) {
            const backButton = new Button(this, 35 * GameVars.scaleX, 35, "texture_atlas_1", "btn_back.png", "btn_back.png", true, true);
            backButton.scaleX = GameVars.scaleX;
            backButton.onUp(this.onClickBack, this);
            this.add.existing(backButton);
        }

        let keys = Object.keys(GameVars.botsInfo);

        this.avatars = [];

        for (let i = 0; i < 7; i++) {
            let avatar = new AvatarSpine(this, 20 + 135 * i, GameConstants.GAME_HEIGHT / 2, keys[i]);
            this.add.existing(avatar);
            this.avatars.push(avatar);
        }

        let offX = 0;
        let offY = -140;

        let button = new Phaser.GameObjects.Graphics(this);
        button.fillStyle(0xffffff, 1);
        button.fillRoundedRect(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100, 10);
        button.setInteractive(new Phaser.Geom.Rectangle(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100), Phaser.Geom.Rectangle.Contains);
        button.on("pointerdown", this.onButton1Down, this);
        this.add.existing(button);

        let text = new Phaser.GameObjects.Text(this, 60 + offX, GameConstants.GAME_HEIGHT - 60 + offY, Translation.getText("CONTENTO_2"), { fontFamily: "Oswald-Medium", fontSize: "14px", color: "#000000" });
        text.setOrigin(.5);
        this.add.existing(text);

        offX += 120;

        button = new Phaser.GameObjects.Graphics(this);
        button.fillStyle(0xffffff, 1);
        button.fillRoundedRect(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100, 10);
        button.setInteractive(new Phaser.Geom.Rectangle(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100), Phaser.Geom.Rectangle.Contains);
        button.on("pointerdown", this.onButton2Down, this);
        this.add.existing(button);

        text = new Phaser.GameObjects.Text(this, 60 + offX, GameConstants.GAME_HEIGHT - 60 + offY, Translation.getText("CONTENTO_1"), { fontFamily: "Oswald-Medium", fontSize: "14px", color: "#000000" });
        text.setOrigin(.5);
        this.add.existing(text);

        offX += 120;

        button = new Phaser.GameObjects.Graphics(this);
        button.fillStyle(0xffffff, 1);
        button.fillRoundedRect(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100, 10);
        button.setInteractive(new Phaser.Geom.Rectangle(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100), Phaser.Geom.Rectangle.Contains);
        button.on("pointerdown", this.onButton3Down, this);
        this.add.existing(button);

        text = new Phaser.GameObjects.Text(this, 60 + offX, GameConstants.GAME_HEIGHT - 60 + offY, Translation.getText("NEUTRO"), { fontFamily: "Oswald-Medium", fontSize: "14px", color: "#000000" });
        text.setOrigin(.5);
        this.add.existing(text);

        offX += 120;

        button = new Phaser.GameObjects.Graphics(this);
        button.fillStyle(0xffffff, 1);
        button.fillRoundedRect(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100, 10);
        button.setInteractive(new Phaser.Geom.Rectangle(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100), Phaser.Geom.Rectangle.Contains);
        button.on("pointerdown", this.onButton4Down, this);
        this.add.existing(button);

        text = new Phaser.GameObjects.Text(this, 60 + offX, GameConstants.GAME_HEIGHT - 60 + offY, Translation.getText("ENFADO_1"), { fontFamily: "Oswald-Medium", fontSize: "14px", color: "#000000" });
        text.setOrigin(.5);
        this.add.existing(text);

        offX += 120;

        button = new Phaser.GameObjects.Graphics(this);
        button.fillStyle(0xffffff, 1);
        button.fillRoundedRect(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100, 10);
        button.setInteractive(new Phaser.Geom.Rectangle(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100), Phaser.Geom.Rectangle.Contains);
        button.on("pointerdown", this.onButton5Down, this);
        this.add.existing(button);

        text = new Phaser.GameObjects.Text(this, 60 + offX, GameConstants.GAME_HEIGHT - 60 + offY, Translation.getText("ENFADO_2"), { fontFamily: "Oswald-Medium", fontSize: "14px", color: "#000000" });
        text.setOrigin(.5);
        this.add.existing(text);

        offX += 120;

        button = new Phaser.GameObjects.Graphics(this);
        button.fillStyle(0xffffff, 1);
        button.fillRoundedRect(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100, 10);
        button.setInteractive(new Phaser.Geom.Rectangle(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100), Phaser.Geom.Rectangle.Contains);
        button.on("pointerdown", this.onButton12Down, this);
        this.add.existing(button);

        text = new Phaser.GameObjects.Text(this, 60 + offX, GameConstants.GAME_HEIGHT - 60 + offY, Translation.getText("CHECK"), { fontFamily: "Oswald-Medium", fontSize: "14px", color: "#000000" });
        text.setOrigin(.5);
        this.add.existing(text);

        offX += 120;

        button = new Phaser.GameObjects.Graphics(this);
        button.fillStyle(0xffffff, 1);
        button.fillRoundedRect(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100, 10);
        button.setInteractive(new Phaser.Geom.Rectangle(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100), Phaser.Geom.Rectangle.Contains);
        button.on("pointerdown", this.onButton6Down, this);
        this.add.existing(button);

        text = new Phaser.GameObjects.Text(this, 60 + offX, GameConstants.GAME_HEIGHT - 60 + offY, Translation.getText("RABIA_BUCLE"), { fontFamily: "Oswald-Medium", fontSize: "14px", color: "#000000" });
        text.setOrigin(.5);
        this.add.existing(text);

        offX += 120;

        button = new Phaser.GameObjects.Graphics(this);
        button.fillStyle(0xffffff, 1);
        button.fillRoundedRect(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100, 10);
        button.setInteractive(new Phaser.Geom.Rectangle(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100), Phaser.Geom.Rectangle.Contains);
        button.on("pointerdown", this.onButton7Down, this);
        this.add.existing(button);

        text = new Phaser.GameObjects.Text(this, 60 + offX, GameConstants.GAME_HEIGHT - 60 + offY, Translation.getText("ALEGRIA_BUCLE"), { fontFamily: "Oswald-Medium", fontSize: "14px", color: "#000000" });
        text.setOrigin(.5);
        this.add.existing(text);

        offY = 0;
        offX = 0;

        button = new Phaser.GameObjects.Graphics(this);
        button.fillStyle(0xffffff, 1);
        button.fillRoundedRect(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100, 10);
        button.setInteractive(new Phaser.Geom.Rectangle(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100), Phaser.Geom.Rectangle.Contains);
        button.on("pointerdown", this.onButton8Down, this);
        this.add.existing(button);

        text = new Phaser.GameObjects.Text(this, 60 + offX, GameConstants.GAME_HEIGHT - 60 + offY, Translation.getText("PAROADE0"), { fontFamily: "Oswald-Medium", fontSize: "14px", color: "#000000" });
        text.setOrigin(.5);
        this.add.existing(text);

        offX += 120;

        button = new Phaser.GameObjects.Graphics(this);
        button.fillStyle(0xffffff, 1);
        button.fillRoundedRect(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100, 10);
        button.setInteractive(new Phaser.Geom.Rectangle(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100), Phaser.Geom.Rectangle.Contains);
        button.on("pointerdown", this.onButton9Down, this);
        this.add.existing(button);

        text = new Phaser.GameObjects.Text(this, 60 + offX, GameConstants.GAME_HEIGHT - 60 + offY, Translation.getText("SALTITO"), { fontFamily: "Oswald-Medium", fontSize: "14px", color: "#000000" });
        text.setOrigin(.5);
        this.add.existing(text);

        offX += 120;

        button = new Phaser.GameObjects.Graphics(this);
        button.fillStyle(0xffffff, 1);
        button.fillRoundedRect(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100, 10);
        button.setInteractive(new Phaser.Geom.Rectangle(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100), Phaser.Geom.Rectangle.Contains);
        button.on("pointerdown", this.onButton10Down, this);
        this.add.existing(button);

        text = new Phaser.GameObjects.Text(this, 60 + offX, GameConstants.GAME_HEIGHT - 60 + offY, Translation.getText("SUDOR"), { fontFamily: "Oswald-Medium", fontSize: "14px", color: "#000000" });
        text.setOrigin(.5);
        this.add.existing(text);

        offX += 120;

        button = new Phaser.GameObjects.Graphics(this);
        button.fillStyle(0xffffff, 1);
        button.fillRoundedRect(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100, 10);
        button.setInteractive(new Phaser.Geom.Rectangle(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100), Phaser.Geom.Rectangle.Contains);
        button.on("pointerdown", this.onButton11Down, this);
        this.add.existing(button);

        text = new Phaser.GameObjects.Text(this, 60 + offX, GameConstants.GAME_HEIGHT - 60 + offY, Translation.getText("TIC"), { fontFamily: "Oswald-Medium", fontSize: "14px", color: "#000000" });
        text.setOrigin(.5);
        this.add.existing(text);

        offX += 120;

        button = new Phaser.GameObjects.Graphics(this);
        button.fillStyle(0xffffff, 1);
        button.fillRoundedRect(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100, 10);
        button.setInteractive(new Phaser.Geom.Rectangle(10 + offX, GameConstants.GAME_HEIGHT - 110 + offY, 100, 100), Phaser.Geom.Rectangle.Contains);
        button.on("pointerdown", this.onButton13Down, this);
        this.add.existing(button);

        text = new Phaser.GameObjects.Text(this, 60 + offX, GameConstants.GAME_HEIGHT - 60 + offY, Translation.getText("CHECK_CARDS"), { fontFamily: "Oswald-Medium", fontSize: "14px", color: "#000000" });
        text.setOrigin(.5);
        this.add.existing(text);
    }

    private onButton1Down(): void {

        for (let i = 0; i < this.avatars.length; i++) {
            this.avatars[i].setAvatarState("contento2");
        }
    }

    private onButton2Down(): void {

        for (let i = 0; i < this.avatars.length; i++) {
            this.avatars[i].setAvatarState("contento1");
        }
    }

    private onButton3Down(): void {

        for (let i = 0; i < this.avatars.length; i++) {
            this.avatars[i].setAvatarState("neutro");
        }
    }

    private onButton4Down(): void {

        for (let i = 0; i < this.avatars.length; i++) {
            this.avatars[i].setAvatarState("enfado1");
        }
    }

    private onButton5Down(): void {

        for (let i = 0; i < this.avatars.length; i++) {
            this.avatars[i].setAvatarState("enfado2");
        }
    }

    private onButton6Down(): void {

        for (let i = 0; i < this.avatars.length; i++) {
            this.avatars[i].setTempState("bucle-enfado");
        }
    }

    private onButton7Down(): void {

        for (let i = 0; i < this.avatars.length; i++) {
            this.avatars[i].setTempState("bucle-contento");
        }
    }

    private onButton8Down(): void {

        for (let i = 0; i < this.avatars.length; i++) {
            this.avatars[i].animationBlink();
        }
    }

    private onButton9Down(): void {

        for (let i = 0; i < this.avatars.length; i++) {
            this.avatars[i].setAvatarAnimation(2, "saltito");
        }
    }

    private onButton10Down(): void {

        for (let i = 0; i < this.avatars.length; i++) {
            this.avatars[i].setAvatarAnimation(2, "tic-sudor");
        }
    }

    private onButton11Down(): void {

        for (let i = 0; i < this.avatars.length; i++) {
            this.avatars[i].setAvatarAnimation(2, "tic");
        }
    }

    private onButton12Down(): void {

        for (let i = 0; i < this.avatars.length; i++) {
            this.avatars[i].setTempState("check");
        }
    }

    private onButton13Down(): void {

        for (let i = 0; i < this.avatars.length; i++) {
            this.avatars[i].setAvatarAnimation(2, "checkCards");
        }
    }

    private onClickBack(): void {

        GameManager.enterRoomScene();
    }
}
